<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              终端名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.storeName"
              placeholder="请输入终端名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择终端
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table2
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin2 from '@/mixin/dialogTableCustomMixin2'
// API
import { loadStoreInfoListDataApi } from '@/api/v2/store'

export default {
  name: 'StoreList',
  components: { CustomTable2 },
  mixins: [dialogDragMixin, dialogTableCustomMixin2],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该终端',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          storeName: '',
          certificateNo: '',
          billType: 1
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.multipleSelection = []
        _this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 100 },
          { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 100 },
          { prop: 'countyName', label: '区县', filterColumn: 'county_name', width: 100 },
          { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 120 },
          { prop: 'storeName', label: '店名', filterColumn: 'store_name', width: 150 },
          { prop: 'address', label: '地址', width: 150 },
          { prop: 'realStoreName', label: '实际店名', filterColumn: 'real_store_name', width: 150 },
          { prop: 'realAddress', label: '实际地址', filterColumn: 'real_address', width: 150 },
          { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '维护中', value: 1 }, { label: '停止维护', value: 2 }], width: 100 },
          { prop: 'ownerName', label: '联系人', filterColumn: 'owner_name', width: 120 },
          { prop: 'phone', label: '联系电话', width: 120 },
          { prop: 'remark', label: '备注', width: 200 }
        ]
        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.storeName = ''
        _this.tableList.tableQuery.certificateNo = ''
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadStoreInfoListDataApi(_this.tableList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(_this.tableList, data.list || []);
        _this.tableList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择终端
    selectItemFun () {
      let _this = this;
      if (_this.multipleSelection.length < 1) {
        _this.$message({ message: '请选择终端', type: 'warning' })
        return false
      } else if (_this.multipleSelection.length > 1){
        _this.$message({ message: '只能选择一个终端', type: 'warning' })
        return false
      } else {
        _this.$emit('selectedStoreFun', _this.multipleSelection[0])
        _this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
